import styled from "styled-components";
import { Theme } from "theme";

export const FiltersContainer = styled.div`
  padding: ${Theme.bigPanelPadding};

  @media (max-width: 600px) {
    font-size: 11pt;
    padding-left: 4px;
  }
`;

export const LeaderboardContainer = styled.div`
  text-align: center;
  font-size: 12pt;
  overflow: auto;
`;

export const LeaderboardTable = styled.table`
  border-spacing: 0;
  border-collapse: collapse;
  margin: auto;
  width: 100%;
`;

export const HeaderRow = styled.tr`
  background: ${Theme.tabBackground};
  white-space: nowrap;
  // could be made reusable with a default tr styling??
  th {
    border-bottom: ${Theme.panelContentBorder};
    padding-bottom: 5px;
    padding-top: 5px;

    &:first-child {
      padding-left: ${Theme.bigPanelPaddingHorizontal};
    }

    &:last-child {
      padding-right: ${Theme.bigPanelPaddingHorizontal};
    }
  }
`;

export const LeaderboardRow = styled.tr<{
  highlight: boolean;
  thickBorder: boolean;
  hideBottomBorder?: boolean;
}>`
  cursor: pointer;
  &:hover {
    background: ${Theme.panelHoverBackground};
  }

  // could be made reusable with a default tr styling??
  td {
    border-bottom: ${Theme.panelContentBorder};

    &:first-child {
      padding-left: ${Theme.bigPanelPaddingHorizontal};
    }

    &:last-child {
      padding-right: ${Theme.bigPanelPaddingHorizontal};
    }

    ${({ hideBottomBorder }) => hideBottomBorder === true && `border-bottom: 0`}
    ${({ thickBorder }) =>
      thickBorder && `border-bottom: ${Theme.panelContentBorderStrong}`}
  }

  ${({ highlight }) => highlight && "font-weight: bold; color: green;"}
`;

export const TightLeaderboardCell = styled.td`
  padding: 2px 12px;
`;

export const TotalLeaderboardCell = styled.td`
  padding: 5px 35px;

  @media (max-width: 700px) {
    padding: 3px 8px;
  }
`;

export const LeaderboardCell = styled.td`
  padding: 5px 11px;

  @media (max-width: 700px) {
    padding: 3px 8px;
  }
`;

export const TightLeaderboardHeader = styled.th`
  padding-left: 12px;
  padding-right: 12px;
`;

export const TotalLeaderboardHeader = styled.th`
  padding-left: 35px;
  padding-right: 35px;

  @media (max-width: 700px) {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export const LeaderboardHeader = styled.th`
  padding-left: 11px;
  padding-right: 11px;

  @media (max-width: 700px) {
    padding-left: 8px;
    padding-right: 8px;
  }
`;

export const UsernameCell = styled(LeaderboardCell)`
  text-align: left;
  width: 99%;
`;

export const LeftLeaderboardHeader = styled.th`
  text-align: left;
  padding: 0 0 0 9px;
`;

export const MessageButton = styled.button`
  background: transparent;
  border: 0;
  text-decoration: underline;
  cursor: pointer;
  padding: 0 2px;
  &:hover {
    font-weight: bold;
  }
`;

export const SwitcherContainer = styled.div`
  margin-top: 10px;
  margin-bottom: ${Theme.bigPanelPaddingVertical};
`;
